import { render, staticRenderFns } from "./HomeRouterContainer.vue?vue&type=template&id=3a055fca&"
import script from "./HomeRouterContainer.vue?vue&type=script&lang=js&"
export * from "./HomeRouterContainer.vue?vue&type=script&lang=js&"
import style0 from "./HomeRouterContainer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports